/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from 'react';

function MembershipFAQ({ noHeader, lang }) {
  const [questions, setQuestions] = useState([]);
  const toggleAnswer = (id, e) => {
    e.preventDefault();
    const cloneQuestions = [...questions];
    cloneQuestions.forEach((faq) => {
      if (faq.id === id) {
        faq.isOpen = !faq.isOpen;
      }
    });
    setQuestions(cloneQuestions);
  };

  const faq = {
    en: [
      {
        id: 1,
        title: 'How do I join?',
        answer: 'Your email will contain a login link. Click through to access your Cocktail Lounge membership.',
      },
      {
        id: 2,
        title: 'Where can I track progress?',
        answer: 'You can track your progress by logging into your Cocktail Lounge  account and going to your benefits page. When you level up to a new tier, you will see all the new perks on your benefits page. Cheers to that!',
      },
      {
        id: 3,
        title: 'How is my membership status determined?',
        answer: 'Your Cocktail Lounge tier is based on the points you collect over the year, with many ways to earn beyond just shopping!',
      },
      {
        id: 4,
        title: 'How do I earn?',
        answer: 'There are plenty of ways to rack up points, with shopping being the simplest! For every dollar you spend, you’ll earn 1 point. Just make sure to use the same email at checkout that you used to join. And here’s a bonus—all your purchases from 2024 count toward your points, even if they were made earlier in the year!',
      },
      {
        id: 5,
        title: 'Do tiers/points expire or reset?',
        answer: 'Yes, your tier level is determined by your spending from the current year.',
      },
      {
        id: 6,
        title: 'What happens to my rewards if I return something?',
        answer: 'When you return an item, that amount will be deducted from your yearly spending total.',
      },
      {
        id: 7,
        title: 'Leveling up to the next Tier: How it works',
        answer: 'You’ll advance to the next level as soon as you reach the maximum points for your current tier. There are plenty of ways to earn points beyond shopping—sharing on social media or referring friends can help you rack up points too!',
      },
      {
        id: 8,
        title: 'What are other ways to earn?',
        answer: 'Excellent question! As a part of the Cocktail Lounge, we want to reward you for spreading the word. You’ll earn points every time you share your unique link with friends and family or refer someone to join the Club. Plus, more earning options are coming soon—like writing a review, or tagging and sharing us on Instagram. Stay tuned for updates!',
      },
    ],
  };

  useEffect(() => {
    setQuestions(faq.en);
  }, []);

  return (
    <div className="asset-faq">
      {!noHeader
      && (
      <div className="benefits-summary__header">
        <div className="benefits-summary__header--title">
          <span>FAQ</span>
        </div>
      </div>
      )}
      {questions.map((faq) => (
        <div
          key={faq.id}
          className="asset-faq__item">
          {faq.isOpen
            ? (
              <a
                className="asset-faq__toggle"
                href="#"
                onClick={(e) => toggleAnswer(faq.id, e)}>
                -
              </a>
            )
            : (
              <a
                className="asset-faq__toggle"
                href="#"
                onClick={(e) => toggleAnswer(faq.id, e)}>
                +
              </a>
            )}
          <div
            className="asset-faq__item--question"
            onClick={(e) => toggleAnswer(faq.id, e)}>
            {faq.title}
          </div>
          <div
            className={faq.isOpen ? 'asset-faq__item--answer -open' : 'asset-faq__item--answer'}
            dangerouslySetInnerHTML={{ __html: faq.answer }}>
          </div>
        </div>
      ))}
      
    </div>
  );
}

export default MembershipFAQ;
